import { motion, useInView, useMotionValue } from 'motion/react';
import React, { useEffect, useRef } from 'react';
import { elderFuthark } from '../../../svg/SVGData';
import { animate } from 'motion';
import { shuffle } from '../../../../utils/utils';

const animationBaseDuration = 1;
const baseDelay = .2;

const symbols = shuffle(Object.keys(elderFuthark));

interface EdgeLetterTransitionProps {
    letter: string,
    symbol: string,
    className?: string,
    index?: number
}

const TransitionSlot: React.FC<EdgeLetterTransitionProps> = ({ letter, symbol, className, index }) => {
    const mainRef = useRef(null);
    const isInView = useInView(mainRef);

    // const symbolRotateY = useMotionValue('0deg');
    // const letterRotateY = useMotionValue('0deg');

    const letterOpacity = useMotionValue(0);
    const symbolOpacity = useMotionValue(0);

    const symbolScale = useMotionValue(0);

    const symbolData = elderFuthark[symbol];
    const delay = index ? index * baseDelay : 0;
    const duration = animationBaseDuration + delay;

    // useEffect(() => {
    // isInView ? setMode('letter') : setMode('symbol');

    //     if (isInView) {
    //         animate(symbolRotateY, '90deg', { duration: .5 + delay, ease: 'easeOut' });
    //         animate(letterRotateY, '0deg', { duration: .5 + delay, ease: 'easeOut' });
    //     } else if (!isInView) {
    //         animate(symbolRotateY, '0deg', { duration: .5 + delay, ease: 'easeOut' });
    //         animate(letterRotateY, '90deg', { duration: .5 + delay, ease: 'easeOut' });
    //     }
    // }, [isInView])

    useEffect(() => {
        if (isInView) {
            animate(letterOpacity, 1, { duration: duration, ease: 'easeIn' });
            animate(symbolOpacity, 0, { duration, ease: 'easeOut' });
            animate(symbolScale, 1, { duration: .2 + delay, ease: 'easeOut' })
        } else {
            animate(letterOpacity, 0, { duration: duration + 5, ease: 'easeOut' });
            animate(symbolOpacity, .3, { duration, ease: 'easeOut' });
            animate(symbolScale, 3, { duration: .2 + delay })
        }
    }, [isInView])

    return (
        <div
            ref={mainRef}
            className='relative min-h-min min-w-min'
        >
            <motion.div
                style={{
                    // rotateY: letterRotateY,
                    opacity: letterOpacity
                }}
            >
                <motion.p
                    className={'text-grenze text-neutral-900 text-4xl min-w-min' + (className || '')}
                >
                    {letter}
                </motion.p>
            </motion.div>

            <motion.div
                className='absolute top-0 left-0 w-full h-full flex justify-center items-center p-px'
                style={{
                    // rotateY: symbolRotateY,
                    opacity: symbolOpacity,
                    scale: symbolScale
                }}
            >
                <svg
                    viewBox={symbolData.viewBox}
                >
                    <path
                        fill='none'
                        style={{
                            stroke: '#7f1d1d',
                            strokeWidth: .75
                        }}
                        d={symbolData.d}
                    />
                </svg>
            </motion.div>
        </div>
    )
}

const EdgeLetterTransition: React.FC<{ children: string }> = ({ children }) => {
    const underlineWidth = useMotionValue('0%');

    const mainRef = useRef(null);
    const isInView = useInView(mainRef);

    const underlineDelay = animationBaseDuration + (children.length * baseDelay);

    useEffect(() => {
        isInView ? animate(underlineWidth, '100%', { duration: underlineDelay }) : animate(underlineWidth, '0%', { duration: underlineDelay });
    }, [isInView])

    return (
        <div ref={mainRef} className='flex relative'>
            {children.split('').map((v, i) => <TransitionSlot key={i} letter={v} index={i} symbol={symbols[i % symbols.length]} />)}
            <div className='absolute bottom-0 left-0 mt-2 w-full'>
                <motion.div layout className='h-1 rounded-lg bg-neutral-900' style={{ width: underlineWidth }} />
            </div>
        </div>
    )
}

export default EdgeLetterTransition;